export default "__VITE_ASSET__DcvU2QI3__"